<template>
  <component :is="actionComponent" v-bind="actionProps" class="button">
    {{ button }}
  </component>
</template>

<script>
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'DynamicLink',
  props: {
    button: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
    route: {
      type: Object,
      default: null,
    },
  },
  computed: {
    actionComponent() {
      if (this.page || this.route) {
        return LangRouterLink
      }

      return this.link ? 'a' : null
    },
    actionProps() {
      if (!this.actionComponent) {
        return {}
      }

      if (this.link) {
        return { href: this.link, target: '_blank' }
      }

      return this.route || { to: { name: this.page } }
    },
  },
}
</script>
